export const QA_NAME_AI_VOICE_INPUT = 'ai_voice_input'

export const AIVoiceInputState = {
  Applying: 'applying',
  Connecting: 'connecting',
  Default: 'default',
  Ready: 'ready',
  Recording: 'recording',
}
